<template>
    <b-modal ref="profile_modal" size="lg" bodyClass="p-0"
             v-bind:no-close-on-backdrop=true
             :hide-header=true
             v-model="is_show_modal"
             :dialogClass=dialog_class_draw>

        <template v-slot:modal-header="{ close }">
            <!-- Emulate built in modal header close button action -->
            <b-button size="sm" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>

        <div id="panel_users_list" class="panel mb-0 border-bottom-0 shadow-none">
            <div class="panel-hdr border-faded border-top-0 border-right-0 border-left-0 shadow-0">
                <h2 >
                    <span class="fw-300">ID:{{this.location.id}}</span>
                </h2>
                <div class="panel-toolbar pr-3 pb-2 align-self-end">
                    <button class="btn btn-panel bg-transparent fs-xl w-auto h-auto rounded-0 waves-effect waves-themed" v-on:click="close()">
                        <i class="fal fa-times"></i>
                    </button>
                </div>
            </div>

            <div class="p-2">
                <b-overlay :show="is_load" rounded="sm" >
                    <div class="location_data" v-if="!is_load">
                        <b-tabs content-class="mt-3" v-if="location.id > 0">
                            <b-tab v-for="(tab,index) in draw_tabs" @click="set_active(index)" :title="get_tab_title(tab)" :key="index">
                                <template slot="title">
                                    <slot :location="location" :name="'title_' + tab.index" >
                                        {{get_tab_title(tab)}}
                                    </slot>
                                </template>

                                <slot :location="location" :name="tab.index" >
                                    <component v-bind:is="tab.index" :location="location"></component>
                                </slot>
                            </b-tab>
                        </b-tabs>

                        <slot :location="location" name="location_general_info" v-else>
                            <component is="delivery_general_tab" :location="location"></component>
                        </slot>

                    </div>
                </b-overlay>
            </div>
        </div>

        <template v-slot:modal-footer="{close}">
            <div class="modal-footer">
                <button type="button" v-on:click="close_modal" class="btn btn-secondary waves-effect waves-themed">
                    {{__t("CLOSE")}}
                </button>

                <button type="button" v-on:click="save_location" class="btn btn-primary waves-effect waves-themed">
                    {{__t("SAVE")}}
                </button>
            </div>
        </template>
    </b-modal>
</template>

<script>

import delivery_general_tab from "./tabs/delivery_general_tab";



export default {
    name: "delivery_location_modal",
    props : {
        tabs_advanced : {
            type : Array
        },
    },

    components : {
        delivery_general_tab
    },

    created() {
        EventBus.$on("location_edit", this.work_click);
        try {
            if (this.tabs_advanced.length > 0) {
                this.tabs_advanced.map(tab => {
                    this.tabs.push(tab);
                })
            }
        }
        catch (e) {

        }

    },

    data() {
        return {
            tabs : [
                {
                    index : "delivery_general_tab",
                    title : this.__t('MAIN_SETTINGS'),
                },
               /* {
                    index : "delivery_auto_send",
                    title : this.__t('DELIVERY_AUTO_ATTACH'),
                },*/

            ],
            modal_position : "left",
            is_show_modal: false,
            is_load: false,
            provider_id : 0,
            location: {
                id: 0,
                parent_id : 0,
                title: "",
                uniq_id: "",
                address : "",

                payment_id : 0,
                pay_cache : 0,
                shipping_id : 0,


                link_id : 0,
                source_id : 0
            },

            payments : [],
            worked_org : {
                "title" : ""
            },
        }
    },

    methods : {

        close_modal() {
            this.close();
        },

        close() {
            //this.tabs = [];
            this.location = this.dfault_rest;
            this.provider_id = 0;
            this.is_show_modal = false;
        },

        get_tab_title (tab) {
            if(tab.count > 0) {
                return tab.title;
            }
            return tab.title;
        },

        set_active (obj) {
            for (let tab in this.draw_tabs) {
                this.draw_tabs[tab].is_active = false;
            }
            this.draw_tabs[obj].is_active = true;
            EventBus.$emit('update:tabu', {type: this.draw_tabs[obj].index, user_id: this.user_id});
        },

        work_click(params) {
            let org_id = 0;
            let location_id = 0;
            let org_obj = null;


            if(params.hasOwnProperty("org_id")) {
                org_id = parseInt(params.org_id);
            }

            if(params.hasOwnProperty("location_id")) {
                location_id = parseInt(params.location_id);
            }

            if(params.hasOwnProperty("org_obj")) {
                org_obj = params.org_obj;
            }

            if(params.hasOwnProperty("provider_id")) {
                this.provider_id = params.provider_id;
            }

            this.is_show_modal = true;
            this.location.parent_id = org_id;

            if(org_obj != null) {
                this.worked_org = org_obj;
                if(org_obj.hasOwnProperty("linked_childrens")) {
                    this.location.linked_childrens = org_obj.linked_childrens;
                }
            }

            this.load_location(location_id);
        },

        async load_location(_id) {
            this.is_load = true;
            //this.tabs = [];

            let url = '/deliveries/'+ this.provider_id +'/locations/0';
            if(_id > 0) {
                url = '/deliveries/locations/'+ _id;
            }

            await delivery_api.get(url).then(({data}) => {
                if (data.status === "operation_success") {
                    if(data.data != undefined && data.data.hasOwnProperty("id")) {
                        let cur_org = this.location.parent_id;
                        this.location =  {...this.location, ...data.data}
                        if(cur_org > 0) {
                            this.location.parent_id = cur_org;
                        }
                    }
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });
        },


        async save_location() {
            this.is_load = true;
            let url = '/deliveries/'+ this.provider_id +'/locations/'+ this.location.id;
            if(this.location.id  > 0 ) {
                url = '/deliveries/locations/'+ this.location.id;
            }

            await delivery_api.put(url,{
                'store_item' : this.location
            }).then(({data}) => {

                if (data.status === "operation_success") {
                    EventBus.$emit('reload_locations');
                    this.close();
                }
                this.is_load = false;
            }).catch(({response}) => {
                this.is_load = false;
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
            });

        },
    },
    computed: {

        draw_tabs() {
            return  JSON.parse(JSON.stringify(this.tabs));
        },

        dfault_rest() {
            return {
                id: 0,
                parent_id : 0,
                title: "",
                uniq_id: "",
                address : "",
                payment_id : 0,
                link_id : 0,
                shipping_id : 0,
                pay_cache : 0,
                children : [],

            }
        },

        dialog_class_draw () {
            if(this.modal_position === "left") {
                return "modal-dialog-left modal-lg";
            }

            return "modal-dialog-right modal-lg";
        },
    }
}
</script>

<style scoped>

</style>
